import { useState } from "react";

const useFieldErrors = () => {
  const [fieldErrors, setFieldErrors] = useState([]);

  const cleanFieldErrors = () => {
    setFieldErrors([]);
  };

  return {
    fieldErrors,
    setFieldErrors,
    cleanFieldErrors,
  };
};

export default useFieldErrors;
